import React from "react";
import { Box, Button } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import DownloadIcon from "@mui/icons-material/Download";
import ReplayIcon from "@mui/icons-material/Replay";

const OrderFooter = ({
  expanded,
  setExpanded,
  onReorder,
  stripeReceiptUrl,
}) => (
  <Box
    display="flex"
    justifyContent="space-between"
    alignItems="center"
    flexWrap="wrap">
    <Box />
    <Box display="flex" gap={2} flexWrap="wrap" mt={{ xs: 2, md: 0 }}>
      {stripeReceiptUrl && (
        <Button
          variant="outlined"
          startIcon={<DownloadIcon />}
          component="a"
          href={stripeReceiptUrl}
          target="_blank"
          rel="noopener noreferrer">
          View Receipt
        </Button>
      )}
      {/* <Button
        variant="contained"
        startIcon={<ReplayIcon />}
        onClick={onReorder}>
        Reorder
      </Button> */}
      <Button
        onClick={() => setExpanded((prev) => !prev)}
        size="small"
        variant="text"
        sx={{
          mt: 2,
          px: 2,
          py: 1,
          borderRadius: "20px",
          backgroundColor: "#FFDDD9",
          color: "#FD7762",
          fontWeight: 600,
          textTransform: "none",
          "&:hover": { backgroundColor: "#FFD3D0" },
        }}
        startIcon={
          <ExpandMoreIcon
            sx={{
              transform: expanded ? "rotate(180deg)" : "rotate(0)",
              transition: "transform 0.3s ease",
            }}
          />
        }>
        {expanded ? "Hide Details" : "Show Details"}
      </Button>
    </Box>
  </Box>
);

export default OrderFooter;
